import { rd } from '@passionware/monads';
import { RESOURCE_CORE_FIELD_ICONS } from 'v5/patterns/resource/resourceFieldIcons';
import { FilterEnumConfig } from 'v5/patterns/filters/FilterWidget.types';
import { MergeServices } from 'v5/platform/ts/services';
import {
  GroupsQuery,
  WithGroupsService
} from 'v5/services/io/GroupsService/GroupsService';
import { WithOptionalFilters } from 'v5/api/_common/query/queryUtils';
import { CoreFieldFilters } from 'v5/core/core-fields/core-fields-filters.types';
import { enumFilter } from 'v5/api/_common/query/filters/EnumFilter';
import { booleanFilter } from 'v5/api/_common/query/filters/BooleanFilter';

type ResourceGroupsFilterQuery = WithOptionalFilters<
  CoreFieldFilters & Pick<GroupsQuery['filters'], 'resource_type_model'>
>;

export function createGroupsFilterConfig(
  services: MergeServices<[WithGroupsService]>
): FilterEnumConfig<number, ResourceGroupsFilterQuery> {
  const useGroupOptions = (
    search: string,
    query: ResourceGroupsFilterQuery
  ) => {
    const groups = services.groupsService.useGroups({
      search: search,
      filters: {
        entity_type: enumFilter.ofOneOf([17]),
        archived: booleanFilter.createDefault(false),
        resource_type_id: query.filters?.resource_type_id,
        resource_type_model: query.filters?.resource_type_model
      }
    });
    return rd.map(groups, groups =>
      groups.map(group => ({
        value: group.id,
        label: group.name ?? '(no name)'
      }))
    );
  };

  const useGroupValues = (values: number[]) => {
    const groups = services.groupsService.useGroups({
      search: '',
      filters: {}
    });
    return rd.map(groups, groups =>
      groups
        .filter(group => values.includes(group.id))
        .map(group => ({
          value: group.id,
          label: group.name ?? '(no name)'
        }))
    );
  };

  return {
    label: 'Groups',
    icon: <RESOURCE_CORE_FIELD_ICONS.groups />,
    type: 'enum',
    createDefaultValue: () => ({ operator: 'matchAny', value: [] as number[] }),
    options: {
      useValues: useGroupValues,
      useOptions: useGroupOptions,
      valueType: 'array'
    }
  };
}
